import Axios from 'axios';
import header from './auth/header'

const API_URL = process.env.API_URL + '/api/v1/';
const API_URL_V3 = process.env.API_URL + '/api/v3';

class Funder {
  index() {
    return Axios.get(API_URL + 'funder-list', { headers: header() });
  }

  // show(funder) {
  //   return Axios.get(API_URL + `funder/${funder}`, { headers: header() });
  // }
  show(funder) {
    return Axios.get(API_URL_V3 + `/users/personal/profile`, { headers: header() });
  }

  showFunderOnMitra(funder) {
    return Axios.get(API_URL_V3 + `/pengajuan/mitra/nasabah/${funder}`, { headers: header() });
  }

  showJob(funder) {
    return Axios.get(API_URL_V3 + `/users/personal/job`, { headers: header() });
  }

  showV3(funder) {
    return Axios.get(API_URL_V3 + `/users/mitra/${funder}?with=` +
      [
        'role',
        'profile',
        'profile.sumberDana',
        'profile.tujuanPembukaanRekening',
        'dataPekerjaan',
        'userCorporateDetail',
        'userCorporateDetail.legalEntityType',
        'userCorporateDetail.businessField',
        'userCorporateDetail.accountOpeningPurpose',
        'userCorporateDetail.fundSource',
        'userCorporateDetail.estimatedTransactionValue',
        'userCorporateProfile',
        'userCorporateProfile.position',
        'userCorporateProfile.identityType',
        'userCorporateProfile.residenceStatus',
        'userTilaka',
        'userBank',
        'userBank.bank'
      ].join(','), 
      { headers: header() }
    );
  }
  showCorporateProfile() {
    return Axios.get(API_URL_V3 + `/users/corporate/profile`, 
      { headers: header() }
    );
  }

  showPengajuan(pengajuanId){
    return Axios.get(API_URL + `pengajuan/${pengajuanId}`, { headers: header() });
  }

  downloadFunder(id) {
    return Axios.get(API_URL_V3 + `/pengajuan/download/${id}/detail-funder`, {
      headers: header(),
      responseType: 'blob'
    });
  }
}

export default new Funder();



// WEBPACK FOOTER //
// ./src/api/funder.js